import ContractAuthenticationStatus from '@app/store/contract-authentication/ContractAuthenticationStatus';

import {
  NewDocumentsParticipantsVerificationAttemptResponse,
  postDocumentsParticipantVerificationAttempt,
} from '../../verification/attempt';

interface DocumentsParticipantsAuthsAttemptResponse {
  authId: string;
  authKey: string;
  failureCount: number;
  lastFailedAt?: string;
  status: ContractAuthenticationStatus;
}

const convertToDeprecatedAuthsAttemptResponse = ({
  id,
  verificationKey,
  failureCount,
  lastFailedAt,
  status,
}: NewDocumentsParticipantsVerificationAttemptResponse): DocumentsParticipantsAuthsAttemptResponse => {
  return {
    authId: id,
    authKey: verificationKey,
    failureCount,
    lastFailedAt,
    status: status.toLowerCase() as ContractAuthenticationStatus,
  };
};

/**
 * POST 인증
 *
 * @deprecated This API is forwarded. Due to the path, request and response is changed in standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#9e5efd1351f2460eb87e7ac23d4ba291
 */
// eslint-disable-next-line import/prefer-default-export
export function postDocumentsParticipantsAuthsAttempt({
  authenticationKey,
  authType,
  authValue,
  documentId,
  participantId,
  workspaceId,
}: {
  authenticationId: string;
  authenticationKey: string;
  authType: 'PASSWORD';
  authValue: string;
  documentId: string;
  participantId: string;
  workspaceId: string;
}): Promise<{
  authId: string;
  authKey: string;
  failureCount: number;
  lastFailedAt?: string;
  status: ContractAuthenticationStatus;
}> {
  return postDocumentsParticipantVerificationAttempt({
    verificationKey: authenticationKey,
    methodType: authType,
    passValue: authValue,
    documentId,
    workspaceId,
    participantId,
  }).then((response) => convertToDeprecatedAuthsAttemptResponse(response));
}
